import React, { Component } from 'react';
import { deFormatDate, parseGermanDate } from 'mythil/time';
import replaceall from 'replaceall';
import MaskedInput from '~/components/MaskedInput/MaskedInput';
import { ReadonlyField } from '~/native-ui/Fields/ReadonlyField';
import { Center } from '~/native-ui/native-base';
import { Icon } from '~/native-ui/Icon';
import { Button } from '~/native-ui/Button';
import { DatePickerDialog } from '~/native-ui/DateTimePicker';

export class DateField extends Component {
    static defaultProps = {
        mask: '11.11.1111',
    };

    state = {
        active: false,
    };

    componentDidUpdate = () => {};

    componentDidMount = () => {};

    onChangeMaskInput = (value) => {
        if (value) {
            let valueClean = value.replace(/[:. _]/g, '');
            if (valueClean.length < 1) {
                value = null;
            }
        }

        return this.props.onChange(value);
    };

    onChangeCalendar = (val) => {
        // this.setState({ active: false });

        if (!val) {
            return this.props.onChange(val);
        }

        val = deFormatDate(val);

        return this.props.onChange(val);
    };

    getValue = () => {
        let { value } = this.props;
        if (!value) {
            return '';
        }

        return value;
    };

    getCalendarValue = () => {
        let { value } = this.props;
        if (!value) {
            return new Date();
        }

        value = replaceall('_', '', value);

        return parseGermanDate(value);
    };

    openCalendar = () => {
        this.setState({ active: true });
    };

    closeCalendar = () => {
        this.setState({ active: false });
    };

    renderReadonly = () => {
        let { value } = this.props;
        return (
            <ReadonlyField
                className={this.props.className}
                label={this.props.title}
                value={value}
                tooltip={this.props.tooltip}
            />
        );
    };

    iconProps = { size: 'xs' };
    renderCalendarButton() {
        if (this.props.disabled)
            return (
                <Center>
                    <Icon type="calendar-today" size="xs" />
                </Center>
            );
        return (
            <Center>
                <DatePickerDialog type="auto" value={this.getCalendarValue()} onChange={this.onChangeCalendar}>
                    <Button colorScheme="muted" icon="calendar-today" iconProps={this.iconProps} />
                </DatePickerDialog>
            </Center>
        );
    }

    render() {
        let { trans, okLabelKey = 'ok', cancelLabelKey = 'close' } = this.props;

        if (this.props.isReadonly) {
            return this.renderReadonly();
        }

        return (
            <MaskedInput
                onChange={this.onChangeMaskInput}
                isRevealingMask={true}
                floating={this.props.floating}
                ref={this.props.ref}
                onKeyPress={this.props.onKeyPress}
                style={this.props.style}
                invalid={this.props.invalid}
                error={this.props.validationMessage}
                label={this.props.title}
                tooltip={this.props.tooltip}
                required={this.props.required}
                iconRight={this.renderCalendarButton()}
                value={this.getValue()}
                mask={this.props.mask}
                placeholder={this.props.placeholder}
            />
        );
    }
}
